import { render, staticRenderFns } from "./AdminIndexationOverview.vue?vue&type=template&id=2abb0390&"
import script from "./AdminIndexationOverview.vue?vue&type=script&lang=js&"
export * from "./AdminIndexationOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports